
import { useEffect } from "react";
import { usePopupManager } from "@/hooks/usePopupManager";
import { registerPopupFunctions } from "@/utils/popupUtils";

export const PopupInitializer = () => {
  const popupManager = usePopupManager();
  
  useEffect(() => {
    registerPopupFunctions({
      showCouponPopup: popupManager.showCouponPopup,
      showNotificationPopup: popupManager.showNotificationPopup,
      showConfirmationPopup: popupManager.showConfirmationPopup,
    });
  }, [popupManager]);
  
  return null;
};
